export const VTMN_CARD_VARIANT = {
  TOP_IMAGE: 'top-image',
  SIDE_IMAGE: 'side-image',
  FULL_IMAGE: 'full-image',
};
